"use client";
import React, { useState } from "react";

import { userService } from "@/services/user.service";
import { useForm } from "react-hook-form";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useRouter } from "next/navigation";
import { checkIsLogged } from "@/utlis/authCheck";
import { IconMail, IconLock, IconEyeOpen, IconEyeOff, IconArrowLeft, IconUser } from "./AuthIcons";

export default function Register() {
	checkIsLogged("/");

	const router = useRouter();

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm();

	const [showPassword, setShowPassword] = useState(false);
	const [marketplaceRegister, setMarketplaceRegister] = useState(false);
	const [compliancePrivacy, setCompliancePrivacy] = useState(false);
	const [complianceTerms, setComplianceTerms] = useState(false);

	const onSubmit = async (data) => {
		if (!compliancePrivacy || !complianceTerms) {
			toast.error(
				"Te rugăm să accepți politica de confidențialitate și termenii și condițiile înainte de înregistrare."
			);
			return;
		}

		return userService
			.register(data)
			.then(() => {
				router.push("/autentificare");
			})
			.catch(() => {
				toast.error(
					"Datele introduse nu sunt valide sau sunt folosite de un alt utilizator !"
				);
			});
	};

	return (
		<>
			<style jsx>{`
				/* =========================================================
				   PAGE
				========================================================= */

				.auth-page {
					position: relative;
					width: 100%;
					min-height: 100vh;

					display: flex;
					justify-content: center;
					align-items: flex-start;

					padding: 70px 20px 60px;

					background: #ffffff;

					box-sizing: border-box;
				}

				/* =========================================================
				   TOP BUTTON (back)
				========================================================= */

				.auth-back {
					position: fixed;

					top: 24px;
					left: 28px;

					width: 54px;
					height: 54px;

					display: flex;
					align-items: center;
					justify-content: center;

					border-radius: 50%;

					background: #f7f8fa;

					color: #1f2937;

					text-decoration: none;

					box-shadow:
						0 4px 14px rgba(15, 23, 42, 0.06),
						0 1px 3px rgba(15, 23, 42, 0.04);

					z-index: 20;

					border: 0;
					cursor: pointer;

					transition:
						transform 0.15s ease,
						background 0.15s ease;
				}

				.auth-back:hover {
					background: #f1f3f6;
				}

				.auth-back:active {
					transform: scale(0.94);
				}

				/* =========================================================
				   MAIN CONTENT
				========================================================= */

				.auth-card {
					width: 100%;
					max-width: 620px;

					display: flex;
					flex-direction: column;
					align-items: center;

					box-sizing: border-box;
				}

				/* =========================================================
				   LOGO
				========================================================= */

				.auth-logo-wrap {
					display: flex;
					align-items: center;
					justify-content: center;

					margin-bottom: 8px;
				}

				.auth-logo {
					display: block;

					width: 210px;
					max-width: 70vw;
					height: auto;

					object-fit: contain;
				}

				.auth-tagline {
					margin: 0 0 20px;

					color: #3b82f6;

					font-size: 21px;
					font-weight: 600;

					line-height: 1.3;

					text-align: center;
				}

				.auth-heading {
					margin: 0 0 10px;

					color: #202733;

					font-size: 26px;
					font-weight: 700;

					line-height: 1.2;

					text-align: center;
				}

				.auth-subtext {
					max-width: 480px;

					margin: 0 0 26px;

					color: #6b7280;

					font-size: 15px;
					line-height: 1.5;

					text-align: center;
				}

				/* =========================================================
				   FORM
				========================================================= */

				.auth-card form {
					width: 100%;
					margin: 0;
					padding: 0;
				}

				/* =========================================================
				   INPUT FIELD
				========================================================= */

				.auth-field {
					position: relative;

					width: 100%;
					height: 66px;

					margin-bottom: 16px;

					display: flex;
					align-items: center;

					box-sizing: border-box;

					background: #ffffff;

					border: 1px solid #d9dde4;

					border-radius: 34px;

					overflow: hidden;

					transition:
						border-color 0.2s ease,
						box-shadow 0.2s ease;
				}

				.auth-field:focus-within {
					border-color: #3b82f6;

					box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
				}

				/* =========================================================
				   LEFT ICON
				========================================================= */

				.auth-field-icon {
					position: absolute;

					left: 22px;
					top: 50%;

					width: 21px;
					height: 21px;

					transform: translateY(-50%);

					display: flex;
					align-items: center;
					justify-content: center;

					color: #6b7280;

					pointer-events: none;

					z-index: 2;
				}

				.auth-field-icon :global(svg) {
					width: 21px !important;
					height: 21px !important;

					display: block;
				}

				/* =========================================================
				   INPUT
				========================================================= */

				.auth-input {
					width: 100% !important;
					height: 100% !important;

					margin: 0 !important;

					padding: 0 58px 0 58px !important;

					border: 0 !important;
					outline: 0 !important;

					border-radius: 34px !important;

					background: transparent !important;

					box-shadow: none !important;

					color: #374151 !important;

					font-family: inherit;
					font-size: 17px;
					font-weight: 400;

					line-height: normal;

					box-sizing: border-box;

					-webkit-appearance: none;
					appearance: none;
				}

				.auth-input::placeholder {
					color: #8a96a6 !important;

					opacity: 1;
				}

				.auth-input:focus {
					border: 0 !important;
					outline: 0 !important;
					box-shadow: none !important;
				}

				.auth-input:-webkit-autofill,
				.auth-input:-webkit-autofill:hover,
				.auth-input:-webkit-autofill:focus {
					-webkit-text-fill-color: #374151 !important;

					-webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;

					transition: background-color 9999s ease-in-out 0s;
				}

				/* =========================================================
				   EYE BUTTON
				========================================================= */

				.auth-eye-btn {
					position: absolute;

					right: 17px;
					top: 50%;

					width: 42px;
					height: 42px;

					transform: translateY(-50%);

					display: flex;
					align-items: center;
					justify-content: center;

					padding: 0;

					border: 0 !important;
					outline: none !important;

					border-radius: 50%;

					background: transparent !important;

					color: #8a96a6;

					cursor: pointer;

					z-index: 3;

					box-shadow: none !important;

					transition:
						background 0.15s ease,
						color 0.15s ease;
				}

				.auth-eye-btn:hover {
					background: #f3f4f6 !important;
					color: #4b5563;
				}

				.auth-eye-btn:focus,
				.auth-eye-btn:focus-visible {
					outline: none !important;
					box-shadow: none !important;
				}

				.auth-eye-btn :global(svg) {
					width: 20px !important;
					height: 20px !important;

					display: block;
				}

				.auth-eye-btn.is-active {
					color: #3b82f6;
				}

				/* =========================================================
				   ERROR
				========================================================= */

				.auth-error {
					display: block;

					margin: -7px 0 12px 22px;

					color: #dc2626;

					font-size: 13px;
					font-weight: 500;

					line-height: 1.3;
				}

				/* =========================================================
				   CHECKBOXES
				========================================================= */

				.auth-check {
					display: flex;
					align-items: flex-start;
					gap: 10px;

					margin: 0 4px 14px;

					color: #4b5563;

					font-size: 13px;
					line-height: 1.5;

					cursor: pointer;
				}

				.auth-check input {
					width: 17px;
					height: 17px;

					margin: 2px 0 0;

					flex-shrink: 0;

					accent-color: #3b82f6;
				}

				.auth-check :global(a) {
					color: #3b82f6;
					text-decoration: underline;
				}

				/* =========================================================
				   INFO BOX
				========================================================= */

				.auth-info-box {
					display: flex;
					align-items: flex-start;
					gap: 14px;

					margin-bottom: 18px;
					padding: 18px;

					background: #f0f9ff;

					border: 2px solid #bae6fd;
					border-radius: 16px;
				}

				.auth-info-icon {
					width: 22px;
					height: 22px;

					flex-shrink: 0;

					margin-top: 2px;

					display: flex;
					align-items: center;
					justify-content: center;

					border-radius: 50%;

					background: #0ea5e9;

					color: #ffffff;

					font-size: 13px;
					font-weight: 700;
				}

				.auth-info-text {
					margin: 0;

					color: #0c4a6e;

					font-size: 13.5px;
					line-height: 1.6;
				}

				/* =========================================================
				   PRIMARY BUTTON
				========================================================= */

				.auth-btn-primary {
					width: 100%;
					height: 66px;

					margin-top: 14px;

					display: flex;
					align-items: center;
					justify-content: center;

					border: 0;
					border-radius: 34px;

					background: #3b82f6;
					color: #ffffff;

					font-family: inherit;

					font-size: 18px;
					font-weight: 700;

					cursor: pointer;

					box-shadow: none;

					transition:
						background 0.18s ease,
						transform 0.15s ease,
						box-shadow 0.18s ease;
				}

				.auth-btn-primary:hover {
					background: #2563eb;

					box-shadow: 0 6px 18px rgba(59, 130, 246, 0.18);
				}

				.auth-btn-primary:active {
					transform: scale(0.985);
				}

				.auth-btn-primary:focus,
				.auth-btn-primary:focus-visible {
					outline: none;
				}

				/* =========================================================
				   SECONDARY BUTTON
				========================================================= */

				.auth-btn-ghost {
					width: 100%;
					min-height: 62px;

					margin-top: 12px;

					display: flex;
					align-items: center;
					justify-content: center;

					padding: 14px 20px;

					border: 0;
					border-radius: 32px;

					background: #f5f6f8;

					color: #29313d;

					font-family: inherit;

					font-size: 17px;
					font-weight: 600;

					line-height: 1.2;

					text-align: center;
					text-decoration: none;

					cursor: pointer;

					box-sizing: border-box;

					transition:
						background 0.18s ease,
						transform 0.15s ease;
				}

				.auth-btn-ghost:hover {
					background: #eef0f3;
				}

				.auth-btn-ghost:active {
					transform: scale(0.985);
				}

				/* =========================================================
				   TABLET
				========================================================= */

				@media (max-width: 700px) {
					.auth-page {
						padding: 55px 22px 45px;
					}

					.auth-back {
						top: 18px;
						left: 18px;

						width: 48px;
						height: 48px;
					}

					.auth-logo {
						width: 190px;
					}

					.auth-tagline {
						font-size: 19px;
					}

					.auth-field {
						height: 62px;
					}

					.auth-btn-primary {
						height: 62px;
					}
				}

				/* =========================================================
				   MOBILE
				========================================================= */

				@media (max-width: 480px) {
					.auth-page {
						min-height: 100svh;

						padding: 72px 18px 35px;
					}

					.auth-card {
						max-width: none;
					}

					.auth-logo {
						width: 170px;
					}

					.auth-tagline {
						margin-bottom: 18px;

						font-size: 17px;
					}

					.auth-field {
						height: 60px;

						margin-bottom: 13px;

						border-radius: 30px;
					}

					.auth-field-icon {
						left: 19px;

						width: 19px;
						height: 19px;
					}

					.auth-field-icon :global(svg) {
						width: 19px !important;
						height: 19px !important;
					}

					.auth-input {
						padding-left: 52px !important;
						padding-right: 52px !important;

						font-size: 16px;
					}

					.auth-eye-btn {
						right: 12px;
					}

					.auth-btn-primary {
						height: 60px;

						margin-top: 12px;

						border-radius: 30px;

						font-size: 17px;
					}

					.auth-btn-ghost {
						min-height: 58px;

						border-radius: 29px;

						font-size: 16px;
					}

					.auth-heading {
						font-size: 22px;
					}

					.auth-subtext {
						font-size: 14px;
					}
				}

				/* =========================================================
				   VERY SMALL PHONES
				========================================================= */

				@media (max-width: 360px) {
					.auth-page {
						padding-left: 14px;
						padding-right: 14px;
					}

					.auth-logo {
						width: 155px;
					}

					.auth-field {
						height: 56px;
					}

					.auth-input {
						font-size: 15px;
					}

					.auth-btn-primary {
						height: 56px;
					}

					.auth-btn-ghost {
						min-height: 54px;
					}
				}
			`}</style>

			<div className='auth-page'>
				<button type='button' className='auth-back' aria-label='Înapoi' onClick={() => router.back()}>
					<IconArrowLeft />
				</button>

				<div className='auth-card'>
					<div className='auth-logo-wrap'>
						<img src='/images/register.webp' alt='eMAGYL' className='auth-logo' />
					</div>
					<p className='auth-tagline'>Un cont, mai multe beneficii!</p>
					<h1 className='auth-heading'>Creează-ți contul</h1>
					<p className='auth-subtext'>
						Acces anticipat la reduceri, plus noutăți personalizate, tendințe și promoții.
					</p>

					<form onSubmit={handleSubmit(onSubmit)}>
						<div className='auth-field'>
							<span className='auth-field-icon'>
								<IconUser />
							</span>
							<input
								className='auth-input'
								placeholder='Prenume'
								type='text'
								required
								{...register("firstName", { required: true })}
							/>
						</div>

						<div className='auth-field'>
							<span className='auth-field-icon'>
								<IconUser />
							</span>
							<input
								className='auth-input'
								placeholder='Nume de familie'
								type='text'
								required
								{...register("lastName", { required: true })}
							/>
						</div>

						<div className='auth-field'>
							<span className='auth-field-icon'>
								<IconMail />
							</span>
							<input
								className='auth-input'
								placeholder='Introdu adresa de email'
								type='email'
								autoComplete='email'
								required
								{...register("email", {
									required: true,
									pattern: /^\S+@\S+$/i,
								})}
							/>
						</div>
						{errors.email && (
							<span className='auth-error'>Introdu o adresă de email validă.</span>
						)}

						<div className='auth-field'>
							<span className='auth-field-icon'>
								<IconLock />
							</span>
							<input
								className='auth-input'
								placeholder='Introdu parola'
								type={showPassword ? "text" : "password"}
								autoComplete='new-password'
								required
								{...register("password", { required: true })}
							/>
							<button
								type='button'
								className={`auth-eye-btn${showPassword ? " is-active" : ""}`}
								onClick={() => setShowPassword((v) => !v)}
								aria-label={showPassword ? "Ascunde parola" : "Arată parola"}>
								{showPassword ? <IconEyeOff /> : <IconEyeOpen />}
							</button>
						</div>

						<label className='auth-check'>
							<input
								type='checkbox'
								onChange={() => setMarketplaceRegister(!marketplaceRegister)}
								checked={marketplaceRegister}
							/>
							Apasă dacă dorești înregistrare ca vânzător pe marketplace
						</label>

						<label className='auth-check'>
							<input
								type='checkbox'
								onChange={() => setCompliancePrivacy(!compliancePrivacy)}
								checked={compliancePrivacy}
							/>
							Sunt de acord cu{" "}
							<a href='/politica-de-confidentialitate'>Politica de Confidențialitate</a>
						</label>

						<label className='auth-check'>
							<input
								type='checkbox'
								onChange={() => setComplianceTerms(!complianceTerms)}
								checked={complianceTerms}
							/>
							Sunt de acord cu <a href='/termeni-si-conditii'>Termenii și Condițiile</a>
						</label>

						{marketplaceRegister && (
							<>
								<div className='auth-info-box'>
									<div className='auth-info-icon'>i</div>
									<p className='auth-info-text'>
										<strong>ATENȚIE !</strong> Conturile înregistrate cu funcționalitate de
										acces că vânzător pe marketplace trebuiesc aprobate de către un
										administrator eMagyl. Vă rugăm să vă asigurați că datele introduse sunt
										corecte deoarece ulterior nu vor mai putea fi modificate !
									</p>
								</div>

								<div className='auth-field'>
									<span className='auth-field-icon'>
										<IconUser />
									</span>
									<input
										className='auth-input'
										placeholder='Nume Firmă'
										type='text'
										required
										{...register("nume_firma", { required: true })}
									/>
								</div>

								<div className='auth-field'>
									<span className='auth-field-icon'>
										<IconUser />
									</span>
									<input
										className='auth-input'
										placeholder='CUI Firmă'
										type='text'
										required
										{...register("cui_firma", { required: true })}
									/>
								</div>

								<div className='auth-field'>
									<span className='auth-field-icon'>
										<IconUser />
									</span>
									<input
										className='auth-input'
										placeholder='Număr Înregistrare Firmă'
										type='text'
										required
										{...register("nr_inregistrare_firma", { required: true })}
									/>
								</div>

								<div className='auth-field'>
									<span className='auth-field-icon'>
										<IconUser />
									</span>
									<input
										className='auth-input'
										placeholder='Adresa Firmă'
										type='text'
										required
										{...register("adresa_firma", { required: true })}
									/>
								</div>
							</>
						)}

						<button type='submit' className='auth-btn-primary'>
							Înregistrare
						</button>
					</form>

					<button type='button' className='auth-btn-ghost' onClick={() => router.push("/autentificare")}>
						Ai deja un cont? Autentifică-te
					</button>
				</div>
			</div>
		</>
	);
}
